var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectExisting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    width: 12,
    height: 12,
    rx: 6,
    transform: "rotate(90 12 0)",
    fill: "#FFD822"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.59713 3.84588C2.86776 3.53103 3.24453 3.50632 3.57537 3.84588L6.00113 6.49104L8.42688 3.84588C8.75772 3.50632 9.13511 3.53103 9.40388 3.84588C9.67451 4.16002 9.65713 4.69089 9.40388 4.98598C9.15187 5.28106 6.48963 8.16412 6.48963 8.16412C6.42623 8.23885 6.35025 8.29828 6.26621 8.33888C6.18217 8.37947 6.09181 8.40039 6.00051 8.40039C5.9092 8.40039 5.81884 8.37947 5.7348 8.33888C5.65076 8.29828 5.57478 8.23885 5.51138 8.16412C5.51138 8.16412 2.85038 5.28106 2.59713 4.98598C2.34326 4.69089 2.3265 4.16003 2.59713 3.84588Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectExisting);
export default __webpack_public_path__ + "static/media/select-existing.40d09ac55fe0556c0319c286af215052.svg";
export { ForwardRef as ReactComponent };